module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/label-1st-a387a33bd73819375ee2bfa420377982.png";